import styled from '@emotion/styled';
import makeBtnSize, { Variant } from './makeBtnSize';

type Props = {
	variant?: Variant;
};

const DefaultButton = styled.button<Props>`
	${({ variant = 'large', theme }) => makeBtnSize(variant, theme.breakpoints)};
	font-weight: 700;
	cursor: pointer;
	display: inline-flex;
	align-items: center;
	&:disabled {
		cursor: no-drop;
		background-color: ${({ theme }) => theme.colors.base['grey-3']};
	}

	&:focus:not(:disabled) {
		outline: 4px solid #091ae080;
		outline-offset: 4px;
	}

	.icon {
		margin-right: 3rem;
		display: inline-block;
		font-size: 133.33%;
		line-height: 1rem;
		i:before {
			vertical-align: middle;
		}
	}
`;

export default DefaultButton;
